module.exports = __webpack_public_path__ + "static/media/S13.6528b9d2.png";